import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {Toast} from 'app/shared/toast/toast';

@Component({
   selector: 'app-thank-you',
   templateUrl: './thankyou.component.html',
   styleUrls: ['../reset-password/reset-password.component.css']
})
export class WaitingPageComponent implements OnInit {
   errorMessage: any;
   forgot_key: any;
   email: any;

   constructor(private router: Router,
               private route: ActivatedRoute,
               private service: IdexService, private toast: Toast) {
   }

   ngOnInit() {
      this.route.params.forEach((params: Params) => {
         this.email = params['email'];
      });
   }

   resendEmail() {
      this.service.resendEmail(this.email)
         .subscribe(data => this.toast.success(data.message),
            error => {
               this.errorMessage = <any>error;
            });
   }
}
